// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1jkQc","header":"ReportDetails_header__2iZ-M","title":"ReportDetails_title__1o1Di","left":"ReportDetails_left__2KCca"};